import {
    SET_FILTER_ALL,
    SET_FILTERED
} from './actions';


const initialState =  {
    filtered: [],
    filterAll: ""
}

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_FILTER_ALL:
        return {
            ...state,
            filterAll: action.payload,
        };
        case SET_FILTERED:
        return {
            ...state,
            filtered: action.payload,
        };
        default:
            return state;
    }
}